import React from "react";

export default function GemIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    onClick,
    className,
    style: mergedStyle,
    ...rest
  };

  return React.createElement(
    "svg",
    svgProps,
    React.createElement("path", { d: "M6 3h12l4 6-10 13L2 9Z" }),
    React.createElement("path", { d: "M11 3 8 9l4 13 4-13-3-6" }),
    React.createElement("path", { d: "M2 9h20" })
  );
}
